import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { externalUrlGroupsTranslation } from '../constants';
import { defaultMaxResults } from './constants';
import {
  ClearList, RequestList, ReceiveList, FailList,
  RequestDeleteExternalUrlGroup, ReceiveDeleteExternalUrlGroup, FailDeleteExternalUrlGroup
} from './action-types';
import { api } from './api';
import { mapList } from './map-list';
import { ExternalUrlGroupsSearchModel } from './types-store';
import { replaceTemplateString } from 'app/infrastructure/platform';

export const actionCreators = {

  loadExternalUrlList: (
    model: ExternalUrlGroupsSearchModel,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestList(requestId, model, startIndex === 0));

      try {
        const listResponse = await api.loadExternalUrlList(model, startIndex, maxResults);

        dispatch(new ReceiveList(requestId, mapList(listResponse.results), listResponse.totalNumberOfResults));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.externalUrlGroups,
            translationId: externalUrlGroupsTranslation.no_access_to_external_urls
          });
        }

        dispatch(new FailList(requestId));
      }
    },

  deleteExternalUrlGroup: (id: number, externalUrlText: string, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestDeleteExternalUrlGroup(id));

      try {

        await api.deleteExternalUrlGroup(id);
        dispatch(new ReceiveDeleteExternalUrlGroup(id));
        dispatch(new SuccessNotification(replaceTemplateString(successMessage, externalUrlText)));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailDeleteExternalUrlGroup(id));
      }
    },

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
